<template>
  <Table :rows="rows" :columns="columns" :columnID="'idPrivado'" table-class="table-hover">
    <template #headactions>
      <button class="btn btn-xs btn-icon btn-light-success" @click="onNew">
        <i class="fa fa-plus"></i>
      </button>
    </template>
    <template #rows="{ rows: bodyRows }">
      <PrivadoRow v-for="row in bodyRows" :key="row.idPrivado" :item="row" @store="$emit('store')"></PrivadoRow>
    </template>
  </Table>
</template>

<script>
import PrivadoRow from "./PrivadoRow.vue";
import Table from "../../shared/components/Table.vue";
import { mapGetters } from "vuex";
export default {
  components: { Table, PrivadoRow },
  props: {
    rows: Array,
  },
  computed: {
    columns() {
      return [
        {
          key: "actions",
          label: "",
          width: 105,
          head_class: "text-center",
        },
        {
          key: "codigo",
          label: "Código",
          width: 65,
          head_class: "text-center",
        },
        {
          key: "agencia",
        },
        {
          key: "docVenta",
          label: "Doc. Venta",
          width: 80,
          head_class: "text-center",
        },
        {
          key: "fechaLlegada",
          label: "F. Llegada",
          width: this.hayEditables ? 85 : 70,
          head_class: "text-center",
        },
        {
          key: "fechaSalida",
          label: "F. Salida",
          width: this.hayEditables ? 85 : 70,
          head_class: "text-center",
        },
        {
          key: "idioma",
          width: this.hayEditables ? 70 : 60,
          head_class: "text-center",
        },
        {
          key: "nroAdultos",
          label: "PAX",
          width: 40,
          head_class: "text-center",
        },
        {
          key: "nroNinos",
          label: "CHD",
          width: 40,
          head_class: "text-center",
        },
        {
          key: "nroDocVenta",
          label: "Nro. Doc. Venta",
          width: 100,
          head_class: "text-center",
        },
        {
          key: "pasajero",
        },
      ];
    },
    ...mapGetters("privados", ["hayEditables"]),
  },
  methods: {
    onNew() {
      this.$store.dispatch("privados/newItem");
    },
  },
};
</script>

<style></style>
